import { createRequestType } from "../../helpers/requestType";
import { CallPerf, Event } from "./types";

export const getAllEventsActionType = createRequestType('GET_ALL_EVENTS');

interface getAllEventsRequestAction {
    type: typeof getAllEventsActionType.request;
    payload: any;
}

interface getAllEventsSuccessAction {
    type: typeof getAllEventsActionType.success;
    payload: CallPerf;
}

interface getAllEventsFailureAction {
    type: typeof getAllEventsActionType.failure;
    payload: any;
}

export const getCallEventsActionType = createRequestType('GET_CALL_EVENTS');

interface getCallEventsRequestAction {
    type: typeof getCallEventsActionType.request;
    payload: string;
}

interface getCallEventsSuccessAction {
    type: typeof getCallEventsActionType.success;
    payload: Event[];
}

interface getCallEventsFailureAction {
    type: typeof getCallEventsActionType.failure;
    payload: any;
}

export const getTargetedEventsActionType = createRequestType('GET_TARGETED_EVENTS');

interface getTargetedEventsRequestAction {
    type: typeof getTargetedEventsActionType.request;
    payload: any;
}

interface getTargetedEventsSuccessAction {
    type: typeof getTargetedEventsActionType.success;
    payload: CallPerf;
}

interface getTargetedEventsFailureAction {
    type: typeof getTargetedEventsActionType.failure;
    payload: any;
}

export type AnalyticsActionTypes = getAllEventsRequestAction | getAllEventsSuccessAction | getAllEventsFailureAction | getTargetedEventsRequestAction
    | getTargetedEventsSuccessAction | getTargetedEventsFailureAction | getCallEventsRequestAction | getCallEventsSuccessAction | getCallEventsFailureAction